// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".CommonContactForm-module-formField-3F6X5{margin-block-end:var(--des-dimension-gap-and-padding-general-away-default)}.CommonContactForm-module-disclaimer-2uR_Z{margin-block-start:var(--des-dimension-gap-and-padding-general-near-medium)}", ""]);
// Exports
exports.locals = {
	"formField": "CommonContactForm-module-formField-3F6X5",
	"disclaimer": "CommonContactForm-module-disclaimer-2uR_Z"
};
module.exports = exports;
